module.exports = __webpack_public_path__ + "img/ltkmens-4x.9a1fb33.jpg";